export abstract class CookieStrategyService {
    abstract get(key: string): Promise<string>;
    abstract set(key: string, value: any, options?: any): Promise<any> | void;
    abstract remove(key: string): Promise<string> | void;
}
